import { render } from "./work.html?vue&type=template&id=5450b0d3&scoped=true&ts=true"
import script from "./work.ts?vue&type=script&lang=ts"
export * from "./work.ts?vue&type=script&lang=ts"

import "./work.scss?vue&type=style&index=0&id=5450b0d3&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5450b0d3"]])

export default __exports__